import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useVerticalBrowseStore } from "../../stores/verticalBrowseStore";

interface BrowseModeToggleProps {
  verticalBrowseAvailable: boolean;
  onNavigate?: (path: string) => void;
}

const BrowseModeToggle: React.FC<BrowseModeToggleProps> = ({ verticalBrowseAvailable, onNavigate }) => {
  const mode = useVerticalBrowseStore((state) => state.mode);
  const setMode = useVerticalBrowseStore((state) => state.setMode);
  const browseAvailability = useVerticalBrowseStore((state) => state.browseAvailability);

  if (!verticalBrowseAvailable || browseAvailability !== "allowed") return null;

  const handleChange = (_: React.MouseEvent<HTMLElement>, newMode: "folders" | "verticals" | null) => {
    if (newMode === null) return;
    setMode(newMode);
    onNavigate?.(newMode === "verticals" ? "/main/verticals" : "/main");
  };

  return (
    <ToggleButtonGroup
      value={mode}
      exclusive
      onChange={handleChange}
      aria-label="Browse mode"
      fullWidth
      sx={{
        backgroundColor: "#fff",
        borderRadius: "999px",
        height: "51px",
        overflow: "hidden",
        padding: "8px",
        "&& .MuiToggleButton-root": {
          border: 0,
          borderRadius: "999px",
          color: "#000",
          fontFamily: "Inter",
          fontSize: "1rem",
          fontWeight: 600,
          textTransform: "uppercase",
        },
      }}
    >
      <ToggleButton
        value="folders"
        aria-label="Folders"
        style={{
          backgroundColor: mode === "folders" ? "#0265DC" : "transparent",
          borderRadius: "999px",
          color: mode === "folders" ? "#fff" : "#000",
        }}
      >
        Folders
      </ToggleButton>
      <ToggleButton
        value="verticals"
        aria-label="Verticals"
        style={{
          backgroundColor: mode === "verticals" ? "#0265DC" : "transparent",
          borderRadius: "999px",
          color: mode === "verticals" ? "#fff" : "#000",
        }}
      >
        Verticals
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default BrowseModeToggle;
